import { json } from '@codemirror/lang-json'
import CodeMirror from '@uiw/react-codemirror'
import React, { CSSProperties, useRef, useState } from 'react'

type Props = {
  id?: string
  value?: any
  onChange?: (value: any) => void
  height?: string
  theme?: 'light' | 'dark'
  readonly?: boolean
  style?: CSSProperties
}

export const JsonInput: React.FC<Props> = ({
  id,
  value,
  theme = 'light',
  height,
  readonly = false,
  style,
  onChange,
}) => {
  const isTouched = useRef(false)
  const [isError, setError] = useState(false)
  const [valueLocal, setValueLocal] = useState<any>()

  const handleChange = (editorValue: string) => {
    try {
      const parsedValue = JSON.parse(editorValue)
      setValueLocal(parsedValue)
      setError(false)
      isTouched.current = true
    } catch (err) {
      setError(true)
    }
  }

  const handleBlur = () => {
    if (isTouched.current) {
      onChange?.(valueLocal) // Notify parent with valid JSON
      isTouched.current = false
    }
  }

  return (
    <span id={id}>
      <CodeMirror
        value={JSON.stringify(value, null, 2)} // Prettify initial value
        extensions={[json()]}
        onChange={handleChange}
        onBlur={handleBlur}
        height={height}
        // minHeight="100%"
        // maxHeight="100%"
        theme={theme}
        readOnly={readonly}
        style={{ ...style, outline: isError ? '2px solid red' : undefined }}
      />
    </span>
  )
}
